import React from "react";
import { CalendarCheck, Percent, Truck } from "lucide-react";
import { Button } from "randmarcomps";
import withManufacturer from "../../contexts/WithManufacturer";

interface IProps {
  applicationId: string;
}

const ReturnsActions: React.FC<IProps> = () => {

    //if (createLabel) return (<Navigate to={Path.category(applicationId, product?.category)} />);

    return (
      <div className="mx-1 my-2 flex max-w-[250px] flex-col gap-2">
        <div className="flex flex-col gap-1">
          <p className="px-2 text-sm font-medium text-primary">
            Policies
          </p>
          <Button variant="ghost" disabled className="justify-start px-2">
            <CalendarCheck className="mr-2 h-4 w-4" />
            Edit Days Limit
          </Button>
          <Button variant="ghost" disabled className="justify-start px-2">
            <Percent className="mr-2 h-4 w-4" />
            Edit Defective Allowance
          </Button>
        </div>
        <hr />
        <div className="flex flex-col gap-1">
          <p className="px-2 text-sm font-medium text-primary">
            Utilities
          </p>
          <Button variant="ghost" disabled className="justify-start px-2">
            <Truck className="mr-2 h-4 w-4" />
            Create Return Label
          </Button>
        </div>
      </div>
    );
};

export default withManufacturer(ReturnsActions);
